"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9112],{

/***/ 34215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ColorfulTitleComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12573);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}




var COLOR_END_TAG = "</end>";
var ColorfulTitleComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ColorfulTitleComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ColorfulTitleComponent);
    function ColorfulTitleComponent(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ColorfulTitleComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "renderTitle", function() {
            var _props = _this.props, text = _props.text, fontSize = _props.fontSize, isH1Heading = _props.isH1Heading;
            var title = _this.convertToHtml(text, fontSize);
            var className = "colorful-title";
            var style = {
                fontSize: fontSize
            };
            if (isH1Heading) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: className,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    style: style
                });
            } else {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: className,
                    dangerouslySetInnerHTML: {
                        __html: title
                    },
                    style: style
                });
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ColorfulTitleComponent, [
        {
            key: "convertToHtml",
            value: function convertToHtml(text, fontSize) {
                text = text || "";
                // converting to spans with colors
                var html = "";
                // searching for first '<'
                var index = text.indexOf("<brand");
                if (index === -1) {
                    return text;
                }
                // regular text
                html = text.substring(0, index);
                // getting color
                var colorEndIndex = text.indexOf(">", index);
                var color = text.substring(index + 1, colorEndIndex);
                var endOfColoredText = text.indexOf(COLOR_END_TAG);
                if (endOfColoredText === -1) {
                    endOfColoredText = text.length;
                }
                var colorText = text.substring(colorEndIndex + 1, endOfColoredText);
                html += '<span class="colored" style="color: '.concat(_styles_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z[color], "; font-size: ").concat(fontSize, '">').concat(colorText, "</span>");
                var restOfText = text.substring(endOfColoredText + COLOR_END_TAG.length);
                return html + this.convertToHtml(restOfText);
            }
        },
        {
            key: "render",
            value: function render() {
                var className = this.props.className;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("title-container", className),
                    children: this.renderTitle()
                });
            }
        }
    ]);
    return ColorfulTitleComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);
// This component gets a single text in the form of
// "This is an <brand-blue>Example</end> for a <brand-pink>colorful title</end>."

ColorfulTitleComponent.defaultProps = {
    isH1Heading: false
};


/***/ }),

/***/ 99112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ImagesGalleryRowComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.scss.js

var StyledImagesGalleryRowComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10syk230"
})("display:flex;justify-content:center;flex-wrap:wrap;");

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/paragraph/paragraph-component.js + 1 modules
var paragraph_component = __webpack_require__(94950);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/image-gallery/image-gallery-component.scss.js


var StyledImageGalleryComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekgspoc0"
})("display:flex;justify-content:center;align-items:center;flex-direction:column;position:relative;&.shadow{box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);}&.clickable{cursor:pointer;&:not(:hover){transition:0.2s all ease;}&:hover{transform:scale(1.05);}}a{text-decoration:none;color:", colors/* default.black */.Z.black, ";}.image-text{padding:16px 0;text-align:center;}");

;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/image-gallery/image-gallery-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}






var ImageGalleryComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImageGalleryComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImageGalleryComponent);
    function ImageGalleryComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ImageGalleryComponent);
        var _this;
        _this = _super.call(this, props);
        _this.moveToPage = _this.moveToPage.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ImageGalleryComponent, [
        {
            key: "moveToPage",
            value: function moveToPage() {
                var href = this.props.href;
                window.location.href = href;
            }
        },
        {
            key: "getSpecificImageStyle",
            value: function getSpecificImageStyle() {
                var grayscale = this.props.grayscale;
                var style = grayscale == "true" ? {
                    filter: "grayscale(100%)"
                } : {};
                return style;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, url = _props.url, alt = _props.alt, paragraph = _props.paragraph, shadow = _props.shadow, href = _props.href, screenRatios = _props.screenRatios, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                var specifyStyle = this.getSpecificImageStyle();
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImageGalleryComponent, {
                    className: classnames_default()("image-gallery", {
                        shadow: shadow,
                        clickable: href
                    }),
                    onClick: href ? this.moveToPage : undefined,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            specificImageStyle: specifyStyle,
                            src: url,
                            alt: alt,
                            pictureClass: "social-proof-gallery-picture",
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }),
                        paragraph && /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph_component/* default */.Z, _object_spread({}, paragraph))
                    ]
                });
            }
        }
    ]);
    return ImageGalleryComponent;
}(react.PureComponent);

ImageGalleryComponent.defaultProps = {
    url: "",
    alt: "",
    grayscale: false
};

;// CONCATENATED MODULE: ./components/core/images-gallery/images-gallery-row/images-gallery-row-component.js




function images_gallery_row_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_gallery_row_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_gallery_row_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var ImagesGalleryRowComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ImagesGalleryRowComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ImagesGalleryRowComponent);
    function ImagesGalleryRowComponent() {
        (0,_class_call_check/* default */.Z)(this, ImagesGalleryRowComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ImagesGalleryRowComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, assets = _props.assets, shadow = _props.shadow, screenRatios = _props.screenRatios, grayscale = _props.grayscale, shouldTrackMouseEvents = _props.shouldTrackMouseEvents;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImagesGalleryRowComponent, {
                    className: "images-gallery-row",
                    children: assets.map(function(asset) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageGalleryComponent, _object_spread_props(images_gallery_row_component_object_spread({}, asset), {
                            alt: asset.name,
                            shadow: shadow,
                            grayscale: grayscale,
                            screenRatios: screenRatios,
                            shouldTrackMouseEvents: shouldTrackMouseEvents
                        }), "".concat(asset.url, "_").concat(asset.name));
                    })
                });
            }
        }
    ]);
    return ImagesGalleryRowComponent;
}(react.PureComponent);



/***/ }),

/***/ 94950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ paragraph_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./components/core/colorful-title/colorful-title-component.js
var colorful_title_component = __webpack_require__(34215);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/paragraph/paragraph-component.scss.js



var StyledParagraphComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1y71bb50"
})("display:flex;flex-direction:column;justify-content:center;width:100%;flex:1 1 auto;&.center{align-items:center;text-align:center;.topic,.title,.body{max-width:650px;}}&.right{align-items:flex-end;}&.left{align-items:flex-start;}.topic{font-size:0.875rem;margin-bottom:16px;font-weight:500;}.title{.colorful-title,.colored{line-height:1.3;font-size:2.25rem;font-weight:700;}}.signup-form-with-decorations-wrapper{padding-top:16px;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.title{.colored,.colorful-title{font-size:1.75rem;}}}");
var StyledBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1y71bb51"
})("	font-size:0.875rem;padding-top:16px;width:100%;.inner-body{display:block;line-height:27px;}");
var StyledBottomLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1y71bb52"
})("margin-top:24px;a{color:", colors/* default.black */.Z.black, ";&:hover{color:", colors/* default.brand-purple */.Z["brand-purple"], ";}}");

// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./components/core/picture-with-link/picture-with-link-component.js
var picture_with_link_component = __webpack_require__(94640);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/lodash/replace.js
var replace = __webpack_require__(13880);
var replace_default = /*#__PURE__*/__webpack_require__.n(replace);
;// CONCATENATED MODULE: ./components/core/paragraph/paragraph-component.js







function _define_property1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property1(target, key, source[key]);
        });
    }
    return target;
}











var ParagraphComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ParagraphComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ParagraphComponent);
    function ParagraphComponent() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_class_call_check/* default */.Z)(this, ParagraphComponent);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_to_consumable_array/* default */.Z)(args)));
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderInnerBody", function() {
            var body = _this.props.body;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                children: body.map(function(paragraph, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "inner-body",
                        dangerouslySetInnerHTML: {
                            __html: paragraph
                        }
                    }, index);
                })
            });
        });
        _define_property1((0,_assert_this_initialized/* default */.Z)(_this), "renderBody", function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBody, {
                className: "body",
                children: [
                    " ",
                    _this.renderInnerBody(),
                    " "
                ]
            });
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(ParagraphComponent, [
        {
            key: "renderBottomLink",
            value: function renderBottomLink() {
                var _bottomLink = this.props.bottomLink, text = _bottomLink.text, href = _bottomLink.href;
                var textColor = this.props.textColor;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBottomLink, {
                    className: "bottom-link-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: href,
                        style: {
                            color: colors/* default */.Z[textColor]
                        },
                        children: text
                    })
                });
            }
        },
        {
            key: "renderSignup",
            value: function renderSignup() {
                var _props = this.props, signupForm = _props.signupForm, isFirstSegment = _props.isFirstSegment;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "signup-form-with-decorations-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({
                        emailInputOpened: !!isFirstSegment
                    }, signupForm))
                });
            }
        },
        {
            key: "getTitle",
            value: function getTitle() {
                var _props = this.props, title = _props.title, hasFreeTier = _props.hasFreeTier;
                return hasFreeTier ? replace_default()(title, "Start your 14-day free trial", "") : title;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, image = _props.image, topic = _props.topic, title = _props.title, body = _props.body, textDirection = _props.textDirection, bottomLink = _props.bottomLink, titleFontSize = _props.titleFontSize, showSignup = _props.showSignup, isFirstSegment = _props.isFirstSegment;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledParagraphComponent, {
                    className: classnames_default()("paragraph-component", (0,_define_property/* default */.Z)({}, textDirection, textDirection)),
                    children: [
                        topic.text && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topic",
                            style: {
                                color: colors/* default */.Z[topic.color]
                            },
                            children: topic.text
                        }),
                        title && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "title",
                            children: [
                                image && image.src && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_with_link_component/* default */.Z, _object_spread({
                                    className: "title-image"
                                }, image)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(colorful_title_component/* default */.Z, {
                                    text: this.getTitle(),
                                    fontSize: titleFontSize,
                                    isH1Heading: isFirstSegment
                                })
                            ]
                        }),
                        body.length > 0 && this.renderBody(),
                        bottomLink.href && this.renderBottomLink(),
                        showSignup && this.renderSignup()
                    ]
                });
            }
        }
    ]);
    return ParagraphComponent;
}(react.PureComponent);
/* harmony default export */ var paragraph_component = ((0,segment_context/* withSegmentsData */.c)((0,generic_config_context/* withGenericConfig */.P)(ParagraphComponent)));
ParagraphComponent.defaultProps = {
    topic: {},
    title: "",
    body: [],
    bottomLink: {},
    showSignup: false
};


/***/ })

}]);